import { Component, Input } from '@angular/core';
import { AbstractAtelierView } from '../abstract-atelier.view';

@Component({
  selector: 'app-atelier-immo-task-view',
  templateUrl: './atelier-immo-task-view.component.html',
  styleUrls: ['./atelier-immo-task-view.component.scss']
})
export class AtelierImmoTaskViewComponent extends AbstractAtelierView {
  @Input()
  item;
}
